import { Badge, Flex, Paper, Table } from '@mantine/core'
import FilterChevrons from '@v2/commons/components/FilterTableOrderBy/FilterTableOrderBy.component'
import { OrderByType } from '@v2/commons/interface/enums'
import { formatDate } from '@v2/commons/utils/time'

import { Icons } from 'src/common/components/ui'

import { IEscalation } from '../../escalation.types'
import { openUpdateEscalationModal } from '../../views/UpdateEscalationModal.view'
import { MantineProviderWrapper } from './MantineBadgeColorResolver'
import styles from './escalation-table.module.scss'

interface EscalationTableProps {
  escalations: IEscalation[]
  handleOrderBy: (field: string, orderBy: OrderByType) => void
  filterOrderBy: { field: string; orderBy: OrderByType }
}

const EscalationTable = ({
  escalations,
  handleOrderBy,
  filterOrderBy,
}: EscalationTableProps) => {
  const handleOpenUpdateEscalationModal = (id: string) => {
    openUpdateEscalationModal({
      selectedItem: id,
      drivingLicense: '',
      driverPhoneNumber: '',
    })
  }
  const getEscalaitonStatusClassName = (status: string) => {
    const splitted = status.split(' ')
    return `${splitted[splitted.length - 1]}-status`
  }
  return (
    <MantineProviderWrapper>
      <Table
        layout="fixed"
        classNames={{
          table: styles.table,
          thead: styles['table-head'],
          th: styles['table-th'],
          td: styles['table-td'],
        }}
        highlightOnHover={true}
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>
              <Flex justify="center" align="center" gap="md">
                Name
                <FilterChevrons
                  field="person.lastName"
                  filterOrderBy={filterOrderBy}
                  handleOrderBy={handleOrderBy}
                />
              </Flex>
            </Table.Th>
            <Table.Th>
              <Flex justify="center" align="center" gap="md">
                Program
                <FilterChevrons
                  field="escalation.program"
                  filterOrderBy={filterOrderBy}
                  handleOrderBy={handleOrderBy}
                />
              </Flex>
            </Table.Th>
            <Table.Th>
              <Flex justify="center" align="center" gap="md">
                Priority
                <FilterChevrons
                  field="task.priority"
                  filterOrderBy={filterOrderBy}
                  handleOrderBy={handleOrderBy}
                />
              </Flex>
            </Table.Th>
            <Table.Th>
              <Flex justify="center" align="center" gap="md">
                Status
                <FilterChevrons
                  field="escalation.formStatus"
                  filterOrderBy={filterOrderBy}
                  handleOrderBy={handleOrderBy}
                />
              </Flex>
            </Table.Th>
            <Table.Th>
              <Flex justify="center" align="center" gap="md">
                Assigned To
                <FilterChevrons
                  field="assignedTo.username"
                  filterOrderBy={filterOrderBy}
                  handleOrderBy={handleOrderBy}
                />
              </Flex>
            </Table.Th>
            <Table.Th>
              <Flex justify="center" align="center" gap="md">
                Created Date
                <FilterChevrons
                  field="task.createdAt"
                  filterOrderBy={filterOrderBy}
                  handleOrderBy={handleOrderBy}
                />
              </Flex>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {escalations?.map((escalation) => (
            <Table.Tr
              key={escalation.id}
              onClick={() => handleOpenUpdateEscalationModal(escalation.id)}
            >
              <Table.Td>
                {escalation.person.firstName +
                  ' ' +
                  escalation.person.firstName}
              </Table.Td>
              <Table.Td>{escalation.program}</Table.Td>
              <Table.Td>
                <Badge
                  variant={`${escalation.priority.toLowerCase()}-priority`}
                  radius="sm"
                  className={styles['colored-badge']}
                  leftSection={<Icons.BonfirePriority />}
                >
                  {escalation.priority}
                </Badge>
              </Table.Td>
              <Table.Td>
                <Badge
                  variant={getEscalaitonStatusClassName(escalation.formStatus)}
                  radius="sm"
                  className={styles['colored-badge']}
                  leftSection={<Paper className={styles.circle} />}
                >
                  {escalation.formStatus}
                </Badge>
              </Table.Td>
              <Table.Td>
                {escalation.assignedTo.firstName +
                  ' ' +
                  escalation.assignedTo.lastName}
              </Table.Td>
              <Table.Td>
                {formatDate(escalation.createdAt, 'MM/DD/YYYY')}
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </MantineProviderWrapper>
  )
}

export default EscalationTable
